import { createSlice } from '@reduxjs/toolkit';

export type peopleState = {
  people: any[];
};

const initialState: peopleState = { people: [] };

const peopleSlice = createSlice({
  name: 'people',
  initialState: initialState,
  reducers: {
    handlePeople(state, action) {
      state.people = action.payload;
    }
  }
});

export const { handlePeople } = peopleSlice.actions;

export const peopleReducer = peopleSlice.reducer;
